import AuthAxios from '../../models/Axios'
import * as Types from '../../constants/actionTypes';
import { LOCAL_URL, API_REQUESTS, AUTH_SERVICE_URL } from '../../helper/constant'


/* LIST PORTAL DOCUMENT Functionalities */
export const LIST_PORTAL_DOCUMENTS = (payload) => async (dispatch) => {
    try {
        const { portalId, requestId } = payload
        if (!portalId || !requestId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }

        // console.log(`Entered into list portal documents are:`, payload)
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DOCS_URL}/fetchPortalDocuments`
        const response = await AuthAxios.axios.post(URL, payload)
        if (response.data) {
            dispatch({
                type: Types.PORTAL_DOCS_LIST,
                docList: response.data.data
            })

            if (response.data.docCount >= 0) {
                dispatch({
                    type: Types.PORTAL_DOCS_COUNT,
                    docCount: response.data.docCount
                })
            }
        }


    } catch (error) {
        return dispatch({
            type: Types.PORTAL_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const SET_PORTAL_DOC_ERROR = (message) => (dispatch) => {
    return dispatch({
        type: Types.PORTAL_DOCS_ERROR,
        error: message
    })
}


/* List Request Document Functionalities */
export const IS_SEARCH = (payload) => (dispatch) => {
    return dispatch({
        type: Types.IS_SEARCH,
        data: payload
    })
}
export const LIST_REQUEST_DOCS = (payload) => async (dispatch) => {
    try {
        const { portalId, requestId } = payload
        if (!portalId || !requestId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DOCS_URL}/fetchRequestDocuments`
        const response = await AuthAxios.axios.get(URL, { params: payload })
        if (response.data) {
            dispatch({
                type: Types.REQUEST_DOCS_LIST,
                docList: response.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const LIST_PORTAL_ALL_REQUEST_DOCUMENT_LIST = ({ portalId, clientId, customerName, display, serial_no, asset_tag, country, po_number, request_id, collectionReference, job_description, tesStNo, textSearch, currentPage, itemsPerPage,fromDate,toDate }) => async (dispatch) => {
    try {


        if (!portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DOCS_URL}/fetchPortalRequestDocuments`
        const response = await AuthAxios.axios.get(URL, {params : { portalId, clientId, customerName, display, serial_no, asset_tag, country, po_number, request_id, collectionReference, job_description, tesStNo, textSearch, currentPage, itemsPerPage,fromDate,toDate }})
        if (response.data) {
            dispatch({
                type: Types.PORTAL_ALL_REQUEST_DOCS_LIST,
                docList: response.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const LIST_PORTAL_ALL_REQUEST_DOCUMENT_COUNT = ({ portalId, clientId, customerName, display, serial_no, asset_tag, country, po_number, request_id, collectionReference, job_description, tesStNo, textSearch, currentPage, itemsPerPage,fromDate,toDate }) => async (dispatch) => {
    try {


        if (!portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DOCS_URL}/fetchPortalRequestDocumentsCount`
        const response = await AuthAxios.axios.get(URL, {params :{ portalId, clientId, customerName, display, serial_no, asset_tag, country, po_number, request_id, collectionReference, job_description, tesStNo, textSearch, currentPage, itemsPerPage,fromDate,toDate }})
        if (response.data) {
            dispatch({
                type: Types.PORTAL_ALL_REQUEST_DOCS_COUNT,
                docCount: response.data.data.count
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const LIST_PORTAL_ALL_REQUEST_DOCUMENT_LIST_FOR_INDIVIDUAL_REPORT = ({ portalId, clientId, customerName, display, serial_no, asset_tag, country, po_number, request_id, collectionReference, job_description, tesStNo, textSearch }) => async (dispatch) => {
    try {


        if (!portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DOCS_URL}/fetchPortalRequestDocumentsForIndividualReports`
        const response = await AuthAxios.axios.post(URL, { portalId, clientId, customerName, display, serial_no, asset_tag, country, po_number, request_id, collectionReference, job_description, tesStNo, textSearch })
        if (response.data) {
            dispatch({
                type: Types.PORTAL_ALL_REQUEST_DOCS_LIST_FOR_INDIVIDUAL_REPORTS,
                docList: response.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const GET_INDIVIDUAL_REPORT = ({ portalId, clientId, docTypeId, reportType, index, itemsPerPageForReports, sortBy }) => async (dispatch) => {
    try {

        if (!docTypeId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper document type id`
            })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DOCS_URL}/fetchPortalRequestDocumentsForUniqueReport`
        const response = await AuthAxios.axios.post(URL, { portalId, clientId, docTypeId, reportType, index, itemsPerPageForReports, sortBy})
        if (response.data) {
            dispatch({
                type: Types.GET_INDIVIDUAL_REPORTS,
                data: response.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const GET_INDIVIDUAL_REPORT_COUNT = ({ portalId, clientId, docTypeId, reportType, index, itemsPerPageForReports }) => async (dispatch) => {
    try {
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DOCS_URL}/fetchPortalRequestDocumentsForUniqueReportCount`
        const response = await AuthAxios.axios.post(URL, { portalId, docTypeId, reportType })
        if (response.data) {
            dispatch({
                type: Types.GET_INDIVIDUAL_REPORTS_COUNT,
                data: response.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const ADD_REQUEST_DOCUMENT = (fileData, payload, fileRawPayload = undefined) => async (dispatch) => {
    try {
        const { portalId, requestId, docTypeId } = payload
        if (!fileData) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Request Document Not Found. Please Try again!`
            })
        }
        if (!portalId || !requestId || !docTypeId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Document Type Should Be Selected`
            })
        }
        const REQ_URL = `${AUTH_SERVICE_URL}/portal/createReqDocuments`
        const reqResponse = await AuthAxios.axios.post(REQ_URL, fileData, { params: payload })
        if (payload.isUploadLargeFile && fileRawPayload !== undefined) {
            const fileRaw = fileRawPayload;
            if (!(fileRaw instanceof Blob)) {
                throw new Error('Invalid fileData.');
            }

            if (fileRaw.size === 0) {
                throw new Error('Invalid fileData. File is empty.');
            }

            if (reqResponse && reqResponse.data) {
                const response = reqResponse.data.data

                if (response.PresignedURL && response.PresignedURL.length > 0) {
                    const options = {
                        method: 'PUT',
                        body: fileRaw,
                        headers: {
                            'Content-Type': response.mimetype,
                        },
                    };
                    try {
                        const fetchResponse = await fetch(response.PresignedURL, options);
                        if (fetchResponse.ok) {
                            return response.PresignedURL;
                        } else {
                            throw new Error('File upload failed');
                        }
                    } catch (e) {
                        console.log('File upload failed', e);
                        throw new Error(e);
                    }
                }
            }
        }

        if (reqResponse && reqResponse.data) {
            return dispatch({
                type: Types.ADDED_REQUEST_DOCUMNET,
                addedDoc: reqResponse.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const ADD_ASSET_REQUEST_DOCUMENT = (fileData, payload, fileRawPayload = undefined) => async (dispatch) => {
    try {
        const { portalId, docTypeId } = payload
        if (!fileData) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Request Document Not Found. Please Try again!`
            })
        }
        if (!portalId || !docTypeId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }
        const REQ_URL = `${AUTH_SERVICE_URL}/portal/createReqDocuments`
        const reqResponse = await AuthAxios.axios.post(REQ_URL, fileData, { params: payload })
        if (payload.isUploadLargeFile && fileRawPayload !== undefined) {
            const fileRaw = fileRawPayload;
            if (!(fileRaw instanceof Blob)) {
                throw new Error('Invalid fileData.');
            }

            if (fileRaw.size === 0) {
                throw new Error('Invalid fileData. File is empty.');
            }

            if (reqResponse && reqResponse.data) {
                const response = reqResponse.data.data

                if (response.PresignedURL && response.PresignedURL.length > 0) {
                    const options = {
                        method: 'PUT',
                        body: fileRaw,
                        headers: {
                            'Content-Type': response.mimetype,
                        },
                    };
                    try {
                        const fetchResponse = await fetch(response.PresignedURL, options);
                        if (fetchResponse.ok) {
                            return response.PresignedURL;
                        } else {
                            throw new Error('File upload failed');
                        }
                    } catch (e) {
                        console.log('File upload failed', e);
                        throw new Error(e);
                    }
                }
            }
        }

        if (reqResponse && reqResponse.data) {
            return dispatch({
                type: Types.ADDED_REQUEST_DOCUMNET,
                addedDoc: reqResponse.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}



export const ON_DELETE_REQUEST_DOCUEMENT = (payload) => async (dispatch) => {
    try {
        const { portalId, requestId, id, docEnv } = payload
        if (!portalId || !requestId || !id) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }
        const DEL_URL = `${AUTH_SERVICE_URL}/portal/deleteRequestDocuments`
        await AuthAxios.axios.post(DEL_URL, payload)
        dispatch({
            type: Types.REQUEST_DOC_DELETED,
            delId: id,
            docEnv
        })
    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const ON_ACCEPT_REQUEST_DOCUEMENT = (payload) => async (dispatch) => {
    try {
        const { portalId, id } = payload
        if (!portalId || !id) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }
        const DEL_URL = `${AUTH_SERVICE_URL}/portal/acceptPortalRequestDocuments`
        await AuthAxios.axios.post(DEL_URL, payload)
    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const ON_APPROVE_REQUEST = (payload) => async (dispatch) => {
    try {
      const { id, portalId } = payload;
      if (!id || !portalId) {
        return;
      }
      const APPROVE_REQ_STATUS_URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/approveStatus`
      const response = await AuthAxios.axios.post(APPROVE_REQ_STATUS_URL, payload);
      return response.data;
    } catch (error) {
      let message = error.message
      if (!message && error.error) {
        message = error.error.message
      }
      dispatch({ type: Types.REQUEST_DOCS_ERROR, error: message })
    }
  }

export const DOWNLOAD_REQ_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { requestId, portalId, docName } = payload
        if (!requestId || !portalId || !docName) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })

        }
        const REQ_URL = `${AUTH_SERVICE_URL}/portal/reqDocDownload`
        let url = '';
        const preResponse = await AuthAxios.axios.post(REQ_URL, payload);
        const contentType = preResponse.headers['content-type'];

        if (contentType === 'application/json; charset=utf-8') {
            try {
                let returnData = preResponse.data;
                if(returnData.message === 'LINK-DOWNLOAD'){
                    const { docName } = payload
                    url = returnData.link;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', docName);
                    document.body.appendChild(link);
                    link.click();
                }
            } catch (e) {
               console.log(e);
               throw new Error('Error when handling large file');
            }
        } else {
            const response = await AuthAxios.axios.post(REQ_URL, payload, { responseType: 'blob' })
            url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', docName);
            document.body.appendChild(link);
            link.click();
        }

        setTimeout(function () { URL.revokeObjectURL(url); }, 100); // cleanup
        // dispatch({
        //     type: Types.REQUEST_DOCS_DOWNLOAD,
        //     reqDocDownload: response.data
        // })
    } catch (error) {
        
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const PREVIEW_REQ_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { requestId, portalId, docName } = payload
        if (!requestId || !portalId || !docName) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })

        }
        const REQ_URL = `${AUTH_SERVICE_URL}/portal/reqDocDownload`
        let url = '';
        const preResponse = await AuthAxios.axios.post(REQ_URL, payload);
        const contentType = preResponse.headers['content-type'];

        if (contentType === 'application/json; charset=utf-8') {
            try {
                let returnData = preResponse.data;
                if(returnData.message === 'LINK-DOWNLOAD'){
                    const { docName } = payload
                    url = returnData.link;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', docName);
                    document.body.appendChild(link);
                    link.click();
                }
            } catch (e) {
               console.log(e);
               throw new Error('Error when handling large file');
            }
        } else {
            const response = await AuthAxios.axios.post(REQ_URL, payload, { responseType: 'blob' })
            // url = window.URL.createObjectURL(new Blob([response.data]));
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', docName);
            // document.body.appendChild(link);
            // link.click();
            return response;
        }

        setTimeout(function () { URL.revokeObjectURL(url); }, 100); // cleanup
        // dispatch({
        //     type: Types.REQUEST_DOCS_DOWNLOAD,
        //     reqDocDownload: response.data
        // })
    } catch (error) {
        
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const LIST_PORTAL_EXPORT_ALL_REQUEST_DOCUMENT = ({ portalId, clientId, customerName, display, serial_no, asset_tag, country, po_number, request_id, collectionReference, job_description, tesStNo, textSearch, currentPage, itemsPerPage,fromDate,toDate }) => async (dispatch) => {
    try {
        if (!portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }
        let PROCESS_DATA_LIST = `${AUTH_SERVICE_URL}/portal/reqExcelDocDownload`;
        let filter = { portalId, clientId, customerName, display, serial_no, asset_tag, country, po_number, request_id, collectionReference, job_description, tesStNo, textSearch, currentPage, itemsPerPage,fromDate,toDate };
        //alert(PROCESS_DATA_LIST, filter);
        
        const processList = await AuthAxios.axios.post(PROCESS_DATA_LIST,filter, { responseType: 'blob' });
        return processList && processList.data
    } catch (error) {
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(error) ? await (error.text()) : error.data || {};
        const responseJson = (typeof responseData === "string") ? JSON.parse(responseData) : responseData;
       
        throw new Error(responseJson && responseJson.message);
    }
}

export const DOWNLOAD_CLIENT_TEMPLATE = (payload) => async (dispatch) => {
    try {
        const { requestId, portalId, docName } = payload
        if (!requestId || !portalId || !docName) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })

        }
        const REQ_URL = `${AUTH_SERVICE_URL}/portal/clientTempDownload`
        let url = '';
        const preResponse = await AuthAxios.axios.post(REQ_URL, payload);
        const contentType = preResponse.headers['content-type'];
        if (contentType === 'application/json; charset=utf-8') {
            try {
                let returnData = preResponse.data;
                if(returnData.message === 'LINK-DOWNLOAD'){
                    const { docName } = payload
                    url = returnData.link;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', docName);
                    document.body.appendChild(link);
                    link.click();
                }
            } catch (e) {
               console.log(e);
               throw new Error('Error when handling large file');
            }
        } else {
            const response = await AuthAxios.axios.post(REQ_URL, payload, { responseType: 'blob' })
            url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', docName);
            document.body.appendChild(link);
            link.click();
        }
        setTimeout(function () { URL.revokeObjectURL(url); }, 100); // cleanup
    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const DOWNLOAD_COD_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { requestId, portalId } = payload
        if (!requestId || !portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })

        }
        const REQ_URL = `${AUTH_SERVICE_URL}/portal/reqPortalCODDownload`
        const response = await AuthAxios.axios.post(REQ_URL, payload, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'COD.pdf');
        document.body.appendChild(link);
        link.click();
        setTimeout(function () { URL.revokeObjectURL(url); }, 100); // cleanup

    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const DOWNLOAD_ASSET_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { requestId, portalId, displayId } = payload
        if (!requestId || !portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })
        }
        const REQ_URL = `${LOCAL_URL}/assetexcels/reqAssetExcelDownload`
        let url = '';
        const preResponse = await AuthAxios.axios.post(REQ_URL, payload);
        const contentType = preResponse.headers['content-type'];
        if (contentType === 'application/json; charset=utf-8') {
            try {
                let returnData = preResponse.data;
                if(returnData.message === 'LINK-DOWNLOAD'){
                    const { docName } = payload
                    url = returnData.link;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', docName);
                    document.body.appendChild(link);
                    link.click();
                }
            } catch (e) {
               console.log(e);
               throw new Error('Error when handling large file');
            }
        } else {
            const response = await AuthAxios.axios.post(REQ_URL, payload, { responseType: 'blob' })
            url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'AssetList_' + (displayId || requestId) + '.xlsx');
            document.body.appendChild(link);
            link.click();
        }
        
        setTimeout(function () { URL.revokeObjectURL(url); }, 100); // cleanup

    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const DELETE_ASSET_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { requestId, portalId } = payload
        if (!requestId || !portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })
        }
        const REQ_URL = `${LOCAL_URL}/assetexcels/reqDeleteAssetFile`
        await AuthAxios.axios.post(REQ_URL, payload)
        dispatch({
            type: Types.REQUEST_DOC_DELETED,
            delId: 0
        })
    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const DELETE_CLIENT_ASSET_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { requestId, portalId } = payload
        if (!requestId || !portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })
        }
        const REQ_URL = `${LOCAL_URL}/newrequestassets/reqDeleteClientAssetFile`
        await AuthAxios.axios.post(REQ_URL, payload)
        dispatch({
            type: Types.REQUEST_DOC_DELETED,
            delId: 0
        })
    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const DOWNLOAD_ASSET_COD_COUNT = (payload) => async (dispatch) => {
    try {
        const { requestId } = payload
        if (!requestId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })
        }

        const REQ_URL = `${LOCAL_URL}/assetexcels/downloadCODsCount`
        const responseCount = await AuthAxios.axios.post(REQ_URL, payload);
        let count = 0;
        if (responseCount && responseCount.data) {
            count = responseCount.data.count;
        }
        // reduce number file to avoid timeout api call
        // const MAX_FILES = 150;
        const MAX_FILES = 100;
        let partCODItems = [];
        let totalPages = 0;
        if (count) {
            totalPages = Math.ceil(count / MAX_FILES);
        }
        for (let i = 0; i < totalPages; i++) {
            if (totalPages <= 1) {
                partCODItems.push({ page: i, size: MAX_FILES, part: `${requestId}_Certificate of data Destruction.zip` })
            } else {
                partCODItems.push({ page: i, size: MAX_FILES, part: `${requestId}_Certificate of data Destruction_part${(i + 1)}.zip` })
            }
        }
        return partCODItems;
    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const DOWNLOAD_ASSET_COD = (payload) => async (dispatch) => {
    try {
        const { requestId, part } = payload
        if (!requestId || !part) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })
        }

        const REQ_URL = `${LOCAL_URL}/assetExcels/downloadCODs`
        const response = await AuthAxios.axios.post(REQ_URL, payload, { responseType: 'blob' })//, timeout: 60000
        savingFile(payload.part, response.data);
    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const ON_APPROVE_REQUEST_DOCUEMENT = (payload) => async (dispatch) => {
    try {
        const { portalId, requestId, ids, statusId } = payload
        if (!portalId || !requestId || !ids?.length || !statusId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }
        await AuthAxios.axios.post(`${LOCAL_URL}/requestdocuments/approveRequestDocument`, payload)
    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const SET_REQUEST_DOCUMENT_ERROR = (message) => (dispatch) => {
    dispatch({
        type: Types.REQUEST_DOCS_ERROR,
        error: message
    })
}

export const SET_REQUEST_DOCUMENT_ITEM = (payload) => (dispatch) => {
    dispatch({
        type: Types.REQUEST_DOC_ITEM,
        payload
    })
}

/* --------------------- PROGRAM DOCUMENT TYPES */

export const LIST_PROGRAM_DOCUMENT_TYPES = (portalId) => async (dispatch) => {
    try {
        if (!portalId) {
            dispatch({ type: Types.PROGRAM_DOC_TYPE_ERROR, programDocTypeError: `Portal Did not found` })
        }
        const PROGRAM_DOC_TYPE_URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_DOCUMENT_TYPE_URL}/fetchPortalDocumentTypes`
        const programDocTypeList = await AuthAxios.axios.get(PROGRAM_DOC_TYPE_URL, { params: { portalId: portalId }})
        if (programDocTypeList.data) {
            dispatch({ type: Types.PROGRAM_DOC_TYPE_LIST, programDocTypeList: programDocTypeList.data.data })
            return programDocTypeList.data.data
        }
    } catch (exception) {
        dispatch({ type: Types.PROGRAM_DOC_TYPE_ERROR, programDocTypeError: exception.message })
    }
}

export const ASSET_IMAGE_DOCUMENT_TYPE = (portalId) => async (dispatch) => {
    try {
        if (!portalId) {
            dispatch({ type: Types.PROGRAM_DOC_TYPE_ERROR, programDocTypeError: `Portal Did not found` })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_DOCUMENT_TYPE_URL}/getPortalAssetImageType`
        const resp = await AuthAxios.axios.post(URL, { portalId })
        if (resp.data) {
            dispatch({ type: Types.PROGRAM_DOC_ASSET_IMAGE_TYPE, programAssetImageType: resp.data.data })
        }
    } catch (exception) {
        dispatch({ type: Types.PROGRAM_DOC_TYPE_ERROR, programDocTypeError: exception.message })
    }
}
// export const LIST_ALL_REPORTS = (payload) => async (dispatch) => {
//     const{portalId,docTypeId,index,itemsPerPageForReports} = payload
//     try {
//         if (!portalId) {
//             dispatch({ type: Types.PROGRAM_DOC_TYPE_ERROR, programDocTypeError: `Portal Did not found` })
//         }
//         const PROGRAM_DOC_TYPE_URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_DOCUMENT_TYPE_URL}/fetchAllReports`
//         const reportDocTypeList = await AuthAxios.axios.post(PROGRAM_DOC_TYPE_URL, { portalId,docTypeId,index,itemsPerPageForReports})
//         if (reportDocTypeList.data) {
//             dispatch({ type: Types.FETCH_ALL_REPORTS_BY_DOC_TYPES, reportDocTypeList: reportDocTypeList.data.data })
//         }
//     } catch (exception) {
//         dispatch({ type: Types.PROGRAM_DOC_TYPE_ERROR, programDocTypeError: exception.message })
//     }
// }


/* List Circle Request Document List */
export const LIST_CIRCLE_REQUEST_DOCS = (payload) => async (dispatch) => {
    try {
        const { portalId, requestId } = payload
        if (!portalId || !requestId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide Proper Request Document Information`
            })
        }
        const URL = `${LOCAL_URL}/requestdocuments/fetchRequestCircleDocument`
        const response = await AuthAxios.axios.get(URL, {params: payload})
        if (response.data) {
            dispatch({
                type: Types.REQUEST_CIRCLE_DOCS_LIST,
                docList: response.data.data
            })
            return response.data.data;
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const LIST_ALL_REPORTS_COUNT_BY_DOCTYPEID = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide Proper Request Document Information`
            })
        }
        const URL = `${LOCAL_URL}/requestdocuments/fetchAllReportsCountByDocTypeId`
        const response = await AuthAxios.axios.post(URL, payload)
        if (response.data) {
            dispatch({
                type: Types.REQUEST_CIRCLE_DOCS_LIST_COUNT,
                docListCount: response.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const LIST_ALL_REPORTS = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide Proper Request Document Information`
            })
        }
        const URL = `${LOCAL_URL}/requestdocuments/fetchAllReportsByDocTypeId`
        const response = await AuthAxios.axios.post(URL, payload)
        if (response.data) {
            dispatch({
                type: Types.FETCH_ALL_REPORTS_BY_DOC_TYPES,
                reportDocTypeList: response.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const ON_ADD_PROGRAM_DOCUMENT_TYPE = (payload) => async (dispatch) => {
    try {
        if (!payload || !payload.portalId || !payload.docTypeId) {
            dispatch({ type: Types.PROGRAM_DOC_TYPE_ERROR, programDocTypeError: `Add Program Document Types does not have all required fields` })
        }
        const PROGRAM_DOC_TYPE_URL = `${LOCAL_URL}/portaldocumenttypes/saveDocumentType`
        const response = await AuthAxios.axios.post(PROGRAM_DOC_TYPE_URL, payload)
        if (response.data) {
            dispatch({
                type: Types.ADD_PROGRAM_DOC_TYPE_DATA,
                docList: response.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}
export const ADD_DOCUMENT_TYPES = (payload) => async (dispatch) => {
    try {
        if (!payload || !payload.portalId || !payload.docTypeId) {
            dispatch({ type: Types.PROGRAM_DOC_TYPE_ERROR, programDocTypeError: `Add Program Document Types does not have all required fields` })
        }
        const DOCUMENT_TYPE_URL = `${LOCAL_URL}/documenttypes/saveDocumentType`
        const response = await AuthAxios.axios.post(DOCUMENT_TYPE_URL, payload)
        if (response.data) {
            dispatch({
                type: Types.ON_NEW_REQUEST_DOCUMENT,
                payload: response.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const savingFile = (filename, blob) => {
    if (!(blob instanceof Blob)) {
        blob = new Blob([blob]);
    }
    //saving file
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    } else {
        var URL = window.URL;// || window.webkitURL
        var dURL = URL.createObjectURL(blob);
        if (filename) {
            // use HTML5 a[download] attribute to specify filename
            let a = document.createElement("a");
            // safari doesn't support this yet
            if (typeof a.download === 'undefined') {
                window.open(dURL, '_blank');
            } else {
                a.href = dURL;
                a.download = filename;
                a.rel = 'noopener' // tabnabbing
                //document.body.appendChild(a);
                a.click();
            }
        } else {
            window.open(dURL, '_blank');
        }
        setTimeout(function () { URL.revokeObjectURL(dURL); }, 100); // cleanup
    }
}

export const LIST_ALL_REQUEST_DOCS = (payload) => async (dispatch) => {
    try {
        const { portalId } = { params: payload }
        if (!portalId) {
            return dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please provide proper Request Document Information`
            })
        }
        const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DOCS_URL}/fetchAllRequestDocuments`
        const response = await AuthAxios.axios.get(URL, { params: payload })
        if (response.data) {
            dispatch({
                type: Types.ALL_REQUEST_DOCS_LIST,
                allDocList: response.data.data
            })
        }
    } catch (error) {
        return dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

